import classNames from 'classnames'
import React, { useState, useRef } from 'react'
import SelectList from './list'
import Tile from './tile'
import './index.less'
import Dropdown from '../dropdown'
import { Li } from '../ul'
import Icon from '../../component/icon'
import { findItemByValue, findItemsByValues } from './util'
import DropDownClearIcon from '../dropDownClearIcon'

export { SelectList }

const Select = (props) => {
  const { multi, onChange, placement, disabled, ulStyle, overlayStyle, trigger, container, listClassName, ulProps, ...otherProps } = props
  const List = multi ? SelectList.Multi : SelectList
  const Display = multi ? SelectDisplay.Multi : SelectDisplay
  const [visible, setVisible] = useState(false)
  const onOk = (val, item) => {
    onChange && onChange(val, item)
    setVisible(false)
  }
  const onClear = () => {
    if (multi) {
      onChange && onChange([])
    } else {
      onChange && onChange(null)
    }
    setVisible(false)
  }
  return <Dropdown
    getPopupContainer={triggerNode => container || triggerNode}
    overlayStyle={overlayStyle}
    trigger={trigger}
    overlay={<List
      {...otherProps}
      ulProps={ulProps}
      onChange={onOk}
      onOk={onOk}
      onClear={onClear}
      visible={visible}
      className={classNames({ 'meinian-select': !multi }, listClassName)}
      style={ulStyle}
    />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
    disabled={disabled}
  >
    <span><Display {...otherProps} visible={visible} onClear={onClear} /></span>
  </Dropdown>
}

Select.Tile = (props) => {
  const { onChange, placement, overlayStyle, getPopupContainer, ...otherProps } = props
  const [visible, setVisible] = useState(false)

  const onOk = (val) => {
    onChange && onChange(val)
    setVisible(false)
  }
  const onClear = () => {
    onChange && onChange(null)
    setVisible(false)
  }
  return <Dropdown
    overlayStyle={overlayStyle}
    overlay={<Tile {...otherProps} onChange={onOk} />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
    getPopupContainer={getPopupContainer}
  >
    <span><SelectDisplay.Level {...otherProps} visible={visible} onClear={onClear} /></span>
  </Dropdown>
}

Select.Cascade = (props) => {
  const { onChange, trigger, placement, overlayStyle, multi = true, ...otherProps } = props
  const [visible, setVisible] = useState(false)
  const $cascade = useRef()

  const onOk = (val, item) => {
    onChange && onChange(val, item)
    setVisible(false)
  }
  const onClear = () => {
    if (multi) {
      onChange && onChange([])
    } else {
      onChange && onChange(undefined)
    }
    setVisible(false)
  }

  return <Dropdown
    overlayStyle={overlayStyle}
    trigger={trigger}
    overlay={<SelectList.Cascade {...otherProps} onOk={onOk} onClear={onClear} visible={visible} ref={$cascade} multi={multi} />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
  >
    <span>{multi ? <SelectDisplay.Cascade {...otherProps} visible={visible} onClear={onClear} />
      : <SelectDisplay.Level {...otherProps} visible={visible} onClear={onClear} />}</span>
  </Dropdown>
}

Select.Group = (props) => {
  const { onChange, placement, data = [], overlayStyle, ...otherProps } = props
  const [visible, setVisible] = useState(false)
  const onOk = (val) => {
    onChange && onChange(val)
    setVisible(false)
  }
  const onClear = () => {
    onChange && onChange(null)
    setVisible(false)
  }
  return <Dropdown
    overlayStyle={overlayStyle}
    overlay={<div className="meinian-select-group-wrapper">
      {data.map(group => <div className="meinian-select-group">
        <Li className="group-label">{group.label}</Li>
        <SelectList
          {...otherProps}
          onChange={onOk}
          onOk={onOk}
          onClear={onClear}
          visible={visible}
          className="meinian-select"
          style={{ overflow: 'visible' }}
          data={group.children}
          allowClear={group.allowClear}
        />
      </div>)}
    </div>}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
  >
    <span><SelectDisplay.Group {...otherProps} visible={visible} onClear={onClear} data={data} /></span>
  </Dropdown>
}

export default Select

export const SelectDisplay = (props) => {
  const { displayTextClassName, className, displayStyle, value = null, data = [], placeholder = '请选择', visible, inner, onClear, allowClear = true, prefix } = props
  return <span className={classNames('meinian-select-display', 'dropDownClearIcon', displayTextClassName, className, { clear: (value || value === 0) && allowClear, active: (value || value === 0) && allowClear, inner })} style={displayStyle}>
    <DropDownClearIcon visible={visible} onClear={() => onClear()}>
      <span className="line-1">{prefix}{data.find(m => value === m.value)?.label || placeholder}</span>
    </DropDownClearIcon>
  </span>
}

SelectDisplay.Multi = (props) => {
  const { className, displayStyle, value = [], data = [], allowClear, placeholder = '请选择', visible, onClear } = props
  return <span className={classNames('meinian-select-display-multi', className, { visible, active: value.length })} style={displayStyle}>
    <span className="line-1">{data.filter(m => value.includes(m.value))?.map(n => n.label)?.join(';') || placeholder}</span>
    <span className={classNames('vis-icon', { allowClear: (value || value === 0) && allowClear })}>{visible ? <Icon type="m-Vxing_shang" style={{ fontSize: '16px' }} /> : <Icon type="m-Vxing_xia" style={{ fontSize: '16px' }} />}</span>
    <Icon type="m-guanbi_tianchong" className={classNames('clear-icon', { allowClear: value.length && allowClear })} onClick={(e) => { e && e.stopPropagation(); onClear() }} />
  </span>
}

SelectDisplay.Level = (props) => {
  const { className, displayStyle, value = null, data = [], allowClear, placeholder = '请选择', visible, inner, onClear, prefix, onlyShowLeaf, showValueAsLabel } = props
  const text = () => {
    if (showValueAsLabel) return value
    const item = findItemByValue(value, data)
    if (!item) return null
    if (!item.parent) return item.label
    if (onlyShowLeaf) return item.label
    return `${item.parent.label}-${item.label}`
  }
  return <span className={classNames('meinian-select-display', className, { visible, active: value !== null, inner })} style={displayStyle}>
    <span className="line-1">{prefix}{text() || placeholder}</span>
    <span className={classNames('vis-icon', { allowClear: (value || value === 0) && allowClear })}>{visible ? <Icon type="m-Vxing_shang" style={{ fontSize: '16px' }} /> : <Icon type="m-Vxing_xia" style={{ fontSize: '16px' }} />}</span>
    <Icon type="m-guanbi_tianchong" className={classNames('clear-icon', { allowClear: value !== null && allowClear })} onClick={(e) => { e && e.stopPropagation(); onClear() }} />
  </span>
}

SelectDisplay.Cascade = (props) => {
  const { className, displayStyle, value = [], data = [], allowClear, placeholder = '请选择', visible, onClear, hiddenSelected } = props
  const text = () => {
    let items = []
    if (hiddenSelected) {
      items = findItemsByValues(value, data)
    } else {
      const newData = data.filter((_, index) => index !== 0)
      items = findItemsByValues(value, newData)
    }
    if (!items || !items.length) return null
    return items.map(m => m.label).join(';')
  }
  return <span className={classNames('meinian-select-display-multi', className, { visible, active: value.length })} style={displayStyle}>
    <span className="line-1">{text() || placeholder}</span>
    <span className={classNames('vis-icon', { allowClear: (value || value === 0) && allowClear })}>{visible ? <Icon type="m-Vxing_shang" style={{ fontSize: '16px' }} /> : <Icon type="m-Vxing_xia" style={{ fontSize: '16px' }} />}</span>
    <Icon type="m-guanbi_tianchong" className={classNames('clear-icon', { allowClear: value?.length && allowClear })} onClick={(e) => { e && e.stopPropagation(); onClear() }} />
  </span>
}
SelectDisplay.Group = (props) => {
  const { className, displayStyle, value = null, data = [], placeholder = '请选择', visible, inner, onClear, allowClear = true, prefix } = props
  return <span className={classNames('meinian-select-display', className, { visible, active: (value || value === 0) && allowClear, inner })} style={displayStyle}>
    <span className="line-1">{prefix}{findItemByValue(value, data)?.label || placeholder}</span>
    <span className={classNames('vis-icon', { allowClear: (value || value === 0) && allowClear })}>{visible ? <Icon type="m-Vxing_shang" style={{ fontSize: '16px' }} /> : <Icon type="m-Vxing_xia" style={{ fontSize: '16px' }} />}</span>
    <Icon type="m-guanbi_tianchong" className={classNames('clear-icon', { allowClear: (value || value === 0) && allowClear })} onClick={(e) => { e && e.stopPropagation(); onClear() }} />
  </span>
}
